import { LayoutGrid, List, BarChart3, Trophy, Settings as SettingsIcon, ShieldCheck } from 'lucide-react';

/** Single source of truth for navigation, shared by the sidebar and the bottom bar. */
export const NAV_ITEMS = [
  { to: '/dashboard', label: 'Dashboard', icon: LayoutGrid },
  { to: '/rides', label: 'Ritten', icon: List },
  { to: '/statistieken', label: 'Statistieken', icon: BarChart3 },
  { to: '/leaderboard', label: 'Leaderboard', icon: Trophy },
  { to: '/settings', label: 'Instellingen', icon: SettingsIcon },
];

export const ADMIN_ITEM = { to: '/admin', label: 'Admin', icon: ShieldCheck };

/**
 * /rides also owns its edit screens, so the Ritten tab has to stay lit while
 * you are inside one. Every other route matches exactly.
 */
export function isNavItemActive(pathname, to) {
  if (to === '/rides') return pathname === '/rides' || pathname.startsWith('/rides/');
  return pathname === to;
}
